import React from 'react';

const CentralizedView = ({children}) => {
    return (
        <div className="centralized-div1">
            <div className="page-view">
                <div className="page-view-inner">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default CentralizedView;


